angular.module('zc.zenclerkS')
  .factory('ZcsDashboardData', ZcsDashboardData);

ZcsDashboardData.$inject = ['$q', 'FacadeV2'];
function ZcsDashboardData($q, FacadeV2) {
  const service = {
    find: find
  };

  return service;

  function find(params) {
    // Take last 2 days to avoid numbers not becoming nulls when day changes,
    // and sort so that we use the latest available data
    // (because aggregate happens at least 3 hours later...)
    let query = {
      params: {
        match: {
          date: { $gte: moment(params.date).subtract(1, 'days').toDate() }
        },
        sort: {
          date: -1
        }
      }
    };

    return $q.all([
      FacadeV2.request(`/apikeys/${params.apikey}/zcs_top_pages_by_canonical_url`, query),
      FacadeV2.request(`/apikeys/${params.apikey}/zcs_top_pages_by_url`, query),
      FacadeV2.request(`/apikeys/${params.apikey}/zcs_top_referrers`, query),
    ]).then(([topPagesByCanonicalUrl, topPagesByUrl, topReferrers]) => {
      return {
        top_pages_by_canonical_url: _.get(topPagesByCanonicalUrl, ['data', 0, 'data']),
        top_pages_by_url: _.get(topPagesByUrl, ['data', 0, 'data']),
        top_referrers: _.get(topReferrers, ['data', 0, 'data']),
      };
    });
  }
}



// WEBPACK FOOTER //
// ./src/zenclerk_s_modules/services/dashboard_data.service.js